import angular from 'angular';
import uiRouter from 'angular-ui-router';
import authComponent from './auth.component';
import login from './login/login';
import signup from './signup/signup';
import forgotPassword from './forgotpassword/forgotpassword';

import AuthFactory from './auth.factory';

let authModule = angular.module('auth', [
    uiRouter,
    login,
    signup,
    forgotPassword
  ])

  .component('auth', authComponent)
  .factory('Auth', AuthFactory)
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';
    $stateProvider.state('auth', {
        url: '/',
        template: '<auth></auth>',
        redirectTo: 'auth.login',
        resolve: {
          currentAuth: (Auth,$state) => {
            // $waitForSignIn returns a promise so the resolve waits for it to complete
            return Auth.$waitForSignIn().then((user) => {
              console.log('user', user);
              if(user)
              $state.go('home');
            }).catch((err) => {
              console.log('err', err);
            });
          }
        }
      })
      .state('auth.login', {
        url: 'login',
        template: '<login></login>'
      })
      .state('auth.signup', {
        url: 'signup',
        template: '<signup></signup>'
      })
      .state('auth.forgotPassword', {
        url: 'resetpassword',
        template: '<forgotpassword></forgotpassword>'
      });
    $urlRouterProvider.otherwise('/');
  })
  .name;

export default authModule;



// WEBPACK FOOTER //
// ./client/app/components/auth/auth.js